<template>
  <v-layout>
    <v-container grid-list-lg fill-height >
      <v-layout row wrap fill-height class="flex_box mt-4" >  
        <v-flex xs12>
             <div class="large_device_search_bar hidden-sm-and-down">
        <v-text-field
          v-model="search"         
         
          cache-items
          class="ml-3"
          flat
          hide-no-data
          hide-details
          label="What items you looking for?"
          solo-inverted
        
        ></v-text-field>
      </div>

        <!-- <div class="large_device_search_bar hidden-sm-and-down">
    <input type="text" v-model="search" placeholder="Search title.."/>
   
  </div> -->

          <!-- <h5 class="text-xs-center">***</h5> -->
          <h2 class="text-xs-center feature_products_title">Luokan <span> Yksityiskohta</span></h2>
          <div class="title_border"></div>
        </v-flex>

       <v-flex xs12 sm3 md3 lg3 xl2   grow class="flex_item" v-for="(product,index) in filteredList" :key="index">
            <v-hover>
          <v-card   max-width="600" 
          class="pa-1 mx-auto" height="Auto"  
          slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`">  
      <v-row>
            <v-img  :src="product.image" aspect-ratio="1" class="ma-4"  contain></v-img>
      </v-row>   
            <v-card-title style="height:165px">
              <div style="width:100%;"  class="text-xs-center">
                    <h4 class="text-xs-center red--text text--darken-3">{{product.code}}</h4>
                <h4 class=" text-xs-center grey--text text--darken-3">{{product.item_name}}</h4>
    <h4 class="green white--text text-xs-center">On Stock</h4>
                <h4 class=" text-xs-center grey--text text--darken-3">Kol ({{product.packageamount}} x ST)</h4>           
                <h4 class="grey--text text--darken-3">{{product.price}} € / {{product.package_price}} €</h4>             
                       <!-- <div class="row layout justify-center text-xs-center"  >    
                <h4 class="grey--text text--darken-3 ">{{product.price}} € / </h4>      
                <h4 class="red--text text--darken-3 text-uppercase"> {{ product.package_price}} €</h4>    
                 </div>                                                          -->
              </div>
              </v-card-title> 
        <v-row >
            <v-card class="my-3" >   
        <v-flex pa-0>
       <v-layout   justify-center row align-center>
                  <v-btn flat  small pa-5 color="primary" @click="decreasecount(product)">
      <v-icon dark>remove</v-icon>
    </v-btn>            
                  {{product.prcount}}         
            <v-btn  flat small pa-5 color="primary"  @click="increasecount(product)">
      <v-icon dark>add</v-icon>
    </v-btn>
      </v-layout >
  </v-flex>                    
            </v-card>
        </v-row>
        <v-row >
           <v-card-actions > 
               <v-flex   pa-0>
             <v-layout   justify-center row align-center>
                <v-btn small flat    color="red"   :to="'/product/' + product.id">Yksityiskohta</v-btn>
            <v-btn  icon flat color="success"  @click="addToCart(product)">
              <v-icon>shopping_cart</v-icon>
            </v-btn>   
            </v-layout >
              </v-flex>   
              </v-card-actions>
        </v-row>
               </v-card>
                   </v-hover>
        </v-flex>  
           
      </v-layout>
    </v-container>
  </v-layout>
</template>         
   
<script>
  import firebase from "firebase";
  import moment from 'moment'; 
  import https, { request } from 'https';
  import axios from "axios";
 //const functions = firebase.functions()
 //functions.useFunctionsEmulator('http://localhost:8080')
import qs from "query-string";
import EventServicex from "@/services/EventService.js"
import CategoryDetail from '../pages/CategoryDetail.vue';



  export default {
  components: { CategoryDetail },    
    data(){
      return{
        currency:null,
         search: '',
        select: null,
        products:[],
        cart:this.$store.getters.cart 
      }
    },
    methods: {
        productInCart(product) {
          const cartItems = this.cart
          for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].product.id === product.id) {
              return i       
            }
          }
          return null
        },
    //      serach(){         
    //        if(this.select!=null) 
    //    this.products=this.products.find(item=>item.code==this.select);
    // },
        increasecount(product)
      {
        product.prcount++;

      } ,  
         decreasecount(product)
      {
        if(product.prcount>1)
        product.prcount--;

      } , 
    
        addToCart(product, quantity){
          
// axios({
//   method: 'post',
//   url: 'http://localhost:5001/elatukku-23ef3/europe-west1/getallproductsx'
// });

//  url: 'http://localhost:5001/elatukku-23ef3/europe-west1/getallproductsx'


      //    EventServicex.getEvents()
      // .then(
      //   events => {
      //    this.products=events;
      //   })      

 console.log("product:" + product.id);
          const index = this.productInCart(product)
          const productQuantity = (!quantity || quantity < 1) ? 1 : parseInt(quantity)
          if (index === null) {
              var items = {
                  product: product,
                  quantity: product.prcount
              }
              //this.$store.commit('catalog/updateCart', items)
              this.$store.commit('updateCart', items)
          }else {
          if(!quantity){
              // If item is already into the cart then add++ quantity       
               var itemsx = {
              index: index,
              quantity: product.prcount
          }
     
          this.$store.commit('updateQuantity', itemsx)

              
          }else{
              // When quantity updated manually
          }
        }        
        },
        removeCart(index){
          this.$store.commit('removeCart', index)     
        }, 
    },
    computed:{
         filteredList() {
      return this.products.filter(post => {
        return post.item_name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
    },   
    created(){
      
   //   this.getEventsData();
    // EventServicex.gettoken().
    // then(
    //   res=>{
    //     let token=res.data;
    //   }
    // )

    // EventServicex.getEventSingle(this.$route.params.category)
    //   .then(
    //     events => {
    //       events.forEach(element => {
    //           this.products.push({
    //         item_name:element.name,
    //           id: element.product_id,                        
    //           image:"",
    //           category_name:"",
    //           timestamp:null
    //         });
    //       });

    //     }) 

// let rex =  axios.post('http://localhost:5001/elatukku-23ef3/us-central1/getcatdetail',{ data:{
//         group_id: this.$route.params.category       
//     }})
//  .then ( ( rex ) => {
//         console.log("message output ="+ rex.data )      
//     })

//   axios.post('http://localhost:5001/elatukku-23ef3/us-central1/getproductslist',{data:{
//      listx:rex.data
//    }}).then(()=>{
// console.log("Completed" )   
//    })

//   axios.post('http://localhost:5001/elatukku-23ef3/us-central1/getcatdetail',{params:{
//      group_id: this.$route.params.category    
//    }}).then(()=>{
// console.log("Completed" )   
//    })

 //https://us-central1-elatukku-23ef3.cloudfunctions.net/getcatdetail
//http://localhost:5001/elatukku-23ef3/us-central1/getcatdetail
 
 axios.post('https://europe-west1-elatukku-23ef3.cloudfunctions.net/getcatdetail?group_id='+this.$route.params.category)
 .then ( res=> {
   Array.from(res.data.result).forEach(element => {
     
     let imagec="";
      var asdx=element.images.find(img=>img.variant=="medium");
       if(asdx!=null)
       imagec=asdx.url;
       else
       {
        imagec=element.images[element.images.length-1].url 
       //imagec="https://firebasestorage.googleapis.com/v0/b/elatukku-23ef3.appspot.com/o/logo%2F0.12103345645406938_logo_jpg.png?alt=media&token=0c8427d7-35e2-4bdf-b56e-7383fa758a75";
       }
  //     imagec="https://lh3.googleusercontent.com/proxy/RmYm146TTG4ULdmaadlRxszw6zRYBvKiHeG63nxr0U0X4SJkmGSYIpClvCVee2Z8Hnuib7pIfIOqkVrGK2FsW-4Dkq2-nflG3b5FoUvvV2JlPROGzk2jC7E_";
  
  let amountc=1;
  let pckid="";
    var asd=element.packages.find(pck=>pck.isdefault==true);
       if(asd!=null)
       {
       amountc=asd.amount;
       pckid=asd.package_id
       }
       else
        amountc=1;


       this.products.push({
              id:element.product_id,
              product_id:element.product_id,
              image:imagec,
              code:element.code,
           //   vat:element.vat,
              vatpercent:element.vatpercent,       
              item_name:element.name,
              iscampaign:false,
              name:element.name,
              packageamount:amountc,
              package_id:pckid,
               price:(Math.round(element.price * 100) / 100).toFixed(2),
              category_name:null,
              package_price:(Math.round(amountc*element.price * 100) / 100).toFixed(2),
               prcount:1
      //        timestamp:moment(doc.data().modifytime).format('ll')
       });
            })     
    })

// axios({
//   method: 'post',
//   url: 'http://localhost:5001/elatukku-23ef3/us-central1/getcatdetail',
//   data: {
//    group_id: this.$route.params.category    
//   }
// });


//  const addAdminRole = functions.httpsCallable('addAdminRole')
//               addAdminRole({email:this.formData.email})
//                   .then(result => {
//                     console.log(result);                          
//                   })

// let rex =  axios.post('http://localhost:5001/elatukku-23ef3/us-central1/getcatdetail',{ params:{
//          group_id: this.$route.params.category       
//      }})
//  .then ( ( rex ) => {
//    rex.body.forEach(change => {
          
//             let doc = change.doc
//             this.products.push({
//               id:doc.data().product_id,
//               image:doc.data().images[1].url,       
//               item_name:doc.data().name,
//                price:doc.data().price,
//               category_name:null
//       //        timestamp:moment(doc.data().modifytime).format('ll')
//             })
          
//         })


// console.log("Completed" )   
 
           
//     })

// let rex =  axios.get('http://localhost:5001/elatukku-23ef3/us-central1/getallproducts')
//  .then ( ( rex ) => {
// console.log("Completed" )   
 
           
//     })

//     var db = firebase.firestore();
//       // Current Currency   
//       db.collection("settings").doc('config').onSnapshot(doc =>{
//         this.currency = doc.data().currency
//       })

//  let cref = db.collection('category').doc(this.$route.params.category).collection('products')

//       cref.onSnapshot(snapshot => {
//         snapshot.docChanges().forEach(change => {
//           if(change.type == 'added'){
//             let doc = change.doc
//             this.products.push({
//               id:doc.data().product_id,
//               image:doc.data().images[1].url,       
//               item_name:doc.data().name,
//                price:doc.data().price,
//               category_name:null
//       //        timestamp:moment(doc.data().modifytime).format('ll')
//             })
//           }
//         })
//       })

 },
  }








//    var createUser = functions.httpsCallable('getcatdetail');
//  var data = {
//             group_id: this.$route.params.category
          
//           };
//            createUser(data)
//             .then(function(resp) {
//               displayAlertStatusUser(resp.data.result, 'alert-success');
//             })
//             .catch(function(error) {
//               var code = error.code;
//               var message = error.message;
//               displayAlertStatusUser(message, 'alert-danger');
//             });

// EventServicex.getCatProduct(this.$route.params.category)
//       .then(
//         events => {
//           events.forEach(element => {
//               this.products.push({
//             item_name:element.name,
//               id: element.product_id,                        
//               image:"",
//               category_name:"",
//               timestamp:null
//             });
//           });

//         }) 




      // Show All Items
      // let cref = db.collection('items').where("item_category","==",this.$route.params.category).orderBy('timestamp', 'desc')

      // cref.onSnapshot(snapshot => {
      //   snapshot.docChanges().forEach(change => {
      //     if(change.type == 'added'){
      //       let doc = change.doc
      //       this.products.push({
      //         id:doc.id,
      //         item_name:doc.data().item_name,
      //         image:doc.data().image,
      //         category_name:doc.data().item_category.category_name,
      //         price:doc.data().price,
      //         quantity:doc.data().quantity,
      //         timestamp:moment(doc.data().timestamp).fromNow('lll')
      //       })
      //     }
      //   })
      // })

   
</script>

<style>
  .flex_box{
    display:flex;
  }
  .flex_item{
    flex:1;
    display:flex;
    flex-wrap:wrap;
    flex-grow: 1;
  }
  
  .flex_wrap{
    text-align:center;
    flex:1;
    display:flex;
    flex-wrap:wrap;
  }
  .flex_wrap>*{
    flex:1 1 100%;
  }
  .flex_box .v-card{
    width:100%;
  }
  .flex_item .headline{
    width:100%;
    margin-bottom:15px;
  }
  .flex_box .v-card__text {
    padding: 0px;
  }
  .flex_box .v-card__title {
    padding:10px  0;
  }
  .overlay{
    position:absolute !important;
    top:0;
    left:0;
    width:100%;
    height:100%;
    opacity:0;
    text-align:center;
    background: rgb(0,0,0,.4)!important;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
   .overlay h2{
    margin-top: 40%;
    color:#FFF;
    padding-left:20%;
    padding-right:20%;
    transform: scale(0);
    transition: all .5s;
    box-shadow: none!important;
  }
  .overlay .v-btn__content{
    transform: scale(0);
    transition: all 0.8s;
    opacity:1;
  } 
  .overlay_container:hover .overlay h2{
    transform: scale(1);
    opacity:1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.39);
  }
  .overlay .v-btn{
    overflow:hidden;
  }
  .overlay_container:hover .v-btn__content{
  transform: scale(1);
  opacity:1;
  }
  .overlay_container:hover .overlay{
    opacity:1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.39);
  }
  .overlay_container:hover .v-card__title{
    opacity:0;
  }  
  .details{
    position:absolute;
    bottom:0;
    left:0;
    text-align:center;
    width:100%;
    margin:0;
    padding: 0;
  }
  .details .v-btn{
    width:100%;
  }
  .flex_box h5{
    font-size: 24px!important;
    letter-spacing: 0.4px!important;
    line-height: 15px;
    font-family: 'Yesteryear', cursive;
    text-transform: capitalize;
    color:#3E3939;
  }
  .feature_products_title{
    font-weight: 600;
    font-size: 35px;
    color: #3E3939;
    margin:0px 0px 15px;
    font-family: 'Lobster Two', cursive;
    text-transform: capitalize;
  }
</style>
   


   // NEW API QUERY ---------------------------------------

// const URL1="elatukkutest.tehden.com/oauth/oaclient/token";
//       const requestBody = qs.stringify({
//   client_id: 'Cemet_shop',
//   client_secret: 'c5LXUaauaQk6ZPShB6Zh',
//   grant_type: 'password',
//   username: 'Cemet_shop_uQeaxuuGv8',
//   password: 'WBJWyWQDKsvLsWAE8rP2',
//   redirect_uri:'https://elatukku.fi'
// });

// var options = {
//   host: URL1,
//   method: 'POST',
//   path: '',
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded',
//     'Content-Length': requestBody.length
//   }
// };

// // request object
// var req = https.request(options, function (res) {
//   var result = '';
//   res.on('data', function (chunk) {
//     result += chunk;
//   });
//   res.on('end', function () {
//     console.log(result);
//   });
//   res.on('error', function (err) {
//     console.log(err);
//   })
// });
 
// // req error
// req.on('error', function (err) {
//   console.log(err);
// });
 
// //send request witht the postData form
// req.write(requestBody);
// req.end();

// const URL1="https://elatukkutest.tehden.com/oauth/oaclient/token";
//       const requestBody = {
//   client_id: 'Cemet_shop',
//   client_secret: 'c5LXUaauaQk6ZPShB6Zh',
//   grant_type: 'password',
//   username: 'Cemet_shop_uQeaxuuGv8',
//   password: 'WBJWyWQDKsvLsWAE8rP2',
//   redirect_uri:'https://elatukku.fi'
// }

// const config = {
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded'
//   }
// }

// axios.defaults.withCredentials=true;

// axios.post(URL1, qs.stringify(requestBody), config)
//   .then((result) => {
//     var token=result.data;
//   })
//   .catch((err) => {
//     var error=console.error(err);

//   })


      // axios({method:"GET","url":"","headers":{"content-type":"application/json"}}).then(result=>{
      //   this.response=result.data;
      // }, error=>{
      //   console.error(error);
      // });


// END API QUERY   ---------------------------


// WEBPACK FOOTER //
// src/components/shop/products/CategoryProduct.vue